module.exports = __webpack_public_path__ + "media/img/pages/companies/cinfo-new-7f2b7a17d044d55d9bf82b9534fc33ee.png";